import React from 'react';
import { useSelector } from 'react-redux';
import { withScriptjs, withGoogleMap, GoogleMap } from 'react-google-maps';

// Config
import config from '../../config';

const GMapHOC = withScriptjs(
  withGoogleMap(({ getMapRef, children, defaultCenter, defaultZoom, ...otherProps }) => (
    <GoogleMap
      defaultZoom={defaultZoom}
      defaultCenter={{
        lng: parseFloat(defaultCenter[0]),
        lat: parseFloat(defaultCenter[1]),
      }}
      ref={getMapRef}
      {...otherProps}
    >
      {children}
    </GoogleMap>
  )),
);

export const GMaps = ({ children, ...otherProps }) => {
  // const GOOGLE_API = 'AIzaSyB5QNAFS8TUlE2q5oEJYfg6t23g-euoqgk';
  // @TODO DE API KEY
  const GOOGLE_API = 'AIzaSyChntayBPyyqxA-2IyJZokEF5s8UGPxMqc';
  const language = useSelector(state => state.intl.locale);
  const region = config.lang.toUpperCase();

  return (
    <GMapHOC
      googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&language=${language}&region=${region}&key=${GOOGLE_API}`}
      {...otherProps}
    >
      {children}
    </GMapHOC>
  );
};
